export const SET_FRESH_ORGANIZATION_KEY = 'SET_FRESH_ORGANIZATION_KEY';
export const SET_FRESH_USER_KEY = 'SET_FRESH_USER_KEY';
export const SET_FRESH_BOARD_KEY = 'SET_FRESH_BOARD_KEY';

export const constants = {
  SET_FRESH_BOARD_KEY,
  SET_FRESH_ORGANIZATION_KEY,
  SET_FRESH_USER_KEY,
};
